import type { LocationResponse, MembershipRole } from "@safeplate/contracts";
import { createContext, useContext } from "react";

export interface ShellContextValue {
  activeLocation: LocationResponse | null;
  activeOrganisationId: string;
  activeRole: MembershipRole;
  locationError: unknown;
  locations: readonly LocationResponse[];
  locationsPending: boolean;
  ownStaffProfileIds: readonly string[];
  refreshLocations: () => Promise<unknown>;
}

export const ShellContext = createContext<ShellContextValue | null>(null);

export function useShell(): ShellContextValue {
  const context = useContext(ShellContext);
  if (!context) {
    throw new Error("useShell must be used inside AppShell");
  }
  return context;
}
